import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
// Collects every task schedule of the tenant, which can take longer than the default timeout on large tenants.
const ReadinessTimeout = 5 * 60 * 1000;
export const useCapacityPlanningReadiness = () => {
    const intl = useIntl();
    return useQuery(['CapacityPlanningReadiness'], ({ signal }) => api.base
        .get('/api/CapacityPlanning/Readiness', { timeout: ReadinessTimeout, signal })
        .then(res => res.data), {
        refetchOnWindowFocus: false,
        retry: false,
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
};
